let objectDraft = null;

export const saveObjectDraft = (draft) => {
  // console.log("saving Object Draft", draft);
  objectDraft = draft;
};

export const consumeObjectDraft = () => {
  const draft = objectDraft;
  // console.log("consuming Object Draft", draft);
  objectDraft = null;
  return draft;
};

export const peekObjectDraft = () => objectDraft;

